module.exports = __webpack_public_path__ + "img/enrollment-admin-login-bg.9a8264aa.png";